export const BETSLIP_LOADER = {
    IDLE: 'idle',
    LOADING: 'loading',
    FINISHED: 'finished'
}